module.exports = __webpack_public_path__ + "static/media/small-icon.a2271614.svg";